module.exports = __webpack_public_path__ + "static/media/IMG_0400.91576993.JPG";